import { render, staticRenderFns } from "./WidgetBuilder.vue?vue&type=template&id=074c19f6&scoped=true&"
import script from "./WidgetBuilder.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilder.vue?vue&type=style&index=0&id=074c19f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c19f6",
  null
  
)

export default component.exports